import Vue from 'vue'

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'

const ECharts = require('vue-echarts') // refers to components/ECharts.vue in webpack

// register component to use
Vue.component('v-chart', ECharts.default)
